import { CultureInfo } from '../culture-info.model';
import { CultureInfoSrLatn } from './sr-Latn';

/**
 * @ignore
 */
export const CultureInfoSrLatnRS: CultureInfo = {
  name: 'sr-Latn-RS',
  displayName: 'Serbian (Latin, Serbia)',
  iso3LanguageCode: 'srp',
  iso2LanguageCode: 'sr',
  ietfLanguageTag: 'sr-Latn-RS',
  parent: CultureInfoSrLatn
};
